import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, UsersIcon, CertificateIcon, HeartIcon } from '../icons/SalesIcons';
export function InstructorSection() {
  return <section className="bg-[#FDF8F4] py-16 md:py-24" data-id="element-253">
      <div className="max-w-6xl mx-auto px-4" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-255">
          <h2 className="font-heading text-3xl md:text-4xl text-[#5C4033] mb-4" data-id="element-256">
            Quién Está Detrás de Este Curso
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-2xl border border-[#C4A882]/30 overflow-hidden" data-id="element-257">
          <div className="grid lg:grid-cols-2 gap-0" data-id="element-258">
            {/* Image */}
            <div className="relative" data-id="element-259">
              <img src="https://cdn.magicpatterns.com/uploads/mRXXxa9bwbipmi21SPqMGV/Gemini_Generated_Image_rwoyndrwoyndrwoy.png" alt="Stefany Querubín - Instructora del curso Ilumina y Crea" className="w-full h-full object-cover" data-id="element-260" />
              {/* Overlay with info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#2D2926] to-transparent p-6" data-id="element-261">
                <h3 className="font-heading text-2xl md:text-3xl text-[#C4A882] mb-1" data-id="element-262">
                  Stefany Querubín
                </h3>
                <p className="text-white text-sm mb-2" data-id="element-263">
                  Instructora Certificada | +1000 Alumnas
                </p>
                <div className="flex items-center gap-1" data-id="element-264">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className="text-[#C4A882]" data-id="element-265" />)}
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-266">
              <div className="space-y-6 text-[#2D2926] leading-relaxed" data-id="element-267">
                <p className="text-lg" data-id="element-268">
                  <strong className="text-[#9B2335]" data-id="element-269">
                    Soy Stefany Querubín.
                  </strong>
                </p>

                <p data-id="element-270">
                  Sí, soy enfermera de profesión. Y esa formación me enseñó algo
                  que aplico cada día en mis cursos:{' '}
                  <strong className="text-[#5C4033]" data-id="element-271">
                    la precisión importa.
                  </strong>
                </p>

                <p data-id="element-272">
                  En salud, los detalles salvan vidas. En velería artesanal, los
                  detalles salvan tus velas — y tu negocio.
                </p>

                <p data-id="element-273">
                  Llevo años dedicada de forma exclusiva a la fabricación y
                  enseñanza de velas artesanales. He diseñado un sistema
                  pedagógico que combina técnica rigurosa con un ambiente de
                  aprendizaje cálido, práctico y progresivo.
                </p>

                <p data-id="element-274">
                  No te voy a hablar desde un pedestal. Te voy a hablar como lo
                  haría una amiga que ya recorrió el camino y quiere que tú no
                  cometas los mismos errores que ella cometió.
                </p>

                <p className="text-lg font-bold text-[#9B2335]" data-id="element-275">
                  Cientos de alumnas ya transformaron su relación con las velas
                  — y muchas de ellas ya venden.
                </p>
              </div>

              {/* Credentials */}
              <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t border-[#C4A882]/30" data-id="element-276">
                <div className="text-center" data-id="element-277">
                  <CertificateIcon size={28} className="text-[#9B2335] mx-auto mb-2" data-id="element-278" />
                  <p className="text-sm font-medium text-[#5C4033]" data-id="element-279">
                    Certificada
                  </p>
                </div>
                <div className="text-center" data-id="element-280">
                  <UsersIcon size={28} className="text-[#9B2335] mx-auto mb-2" data-id="element-281" />
                  <p className="text-sm font-medium text-[#5C4033]" data-id="element-282">
                    +1000 Alumnas
                  </p>
                </div>
                <div className="text-center" data-id="element-283">
                  <HeartIcon size={28} className="text-[#9B2335] mx-auto mb-2" data-id="element-284" />
                  <p className="text-sm font-medium text-[#5C4033]" data-id="element-285">
                    Años de Experiencia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}